import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";

import ViewAtivacaoEfetuada from "../views/ViewAtivacaoEfetuada";
import ContatoZap from "../components/ContatoZap";
import ViewAdicionarPeriodos from "../views/ViewAdicionarPeriodos";

const ContainerComponente = styled.div`
  display: grid;
  @media (min-width: 200px) and (max-width: 299px) and (min-height: 200px) and (max-height: 599px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 200px) and (max-width: 299px) and (min-height: 600px) and (max-height: 799px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 200px) and (max-width: 299px) and (min-height: 800px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 200px) and (max-height: 599px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 600px) and (max-height: 799px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 800px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 200px) and (max-height: 599px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 600px) and (max-height: 799px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 800px) {
    grid-template: 140px 40rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 200px) {
    grid-template: 130px 40rem 30rem / auto;
  }

  @media (min-width: 500px) and (max-width: 699px) and (min-height: 800px) {
    grid-template: 130px 40rem 30rem / auto;
  }

  @media (min-width: 700px) and (max-width: 899px) and (min-height: 200px) {
    grid-template: 130px 40rem 30rem / auto;
  }
  @media (min-width: 700px) and (max-width: 899px) and (min-height: 1000px) {
    grid-template: 130px 50rem 30rem / auto;
  }

  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 200px) {
    grid-template: 130px 50rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 800px) {
    grid-template: 130px 50rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 1200px) {
    grid-template: 130px 50rem 50rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 1400px) {
    grid-template: 130px 50rem 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 200px) {
    grid-template: 100px 1fr 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 800px) {
    grid-template: 100px 80vh 30rem / auto;
  }
`;
const AdicionarPeriodos: React.FC = () => (
  <>
    <ContatoZap />
    <ContainerComponente>
      <ViewAppBar />

      <ViewAdicionarPeriodos />
      <ViewFooter />
    </ContainerComponente>
  </>
);
export default AdicionarPeriodos;
